import { ChainId } from '@shared/utils/config/networks';
export var NetworkEthereumCoins = new Map([
    [
        1,
        {
            address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            name: 'weth',
            symbol: 'weth',
            decimals: 18,
        },
    ],
    [
        ChainId.ARBITRUM,
        {
            address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
    [
        ChainId.OPTIMISM,
        {
            address: '0x4200000000000000000000000000000000000006',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
    [
        ChainId.POLYGON,
        {
            address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
    [
        ChainId.BSC,
        {
            address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
        },
    ],
    [
        ChainId.AVALANCHE,
        {
            address: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
    [
        ChainId.BLAST,
        {
            address: '0x4300000000000000000000000000000000000004',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
    [
        ChainId.FANTOM,
        {
            address: '0x74b23882a30290451A17c44f4F05243b6b58C76d',
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
        },
    ],
    [
        ChainId.SOLANA,
        {
            address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
            name: 'Wormhole',
            symbol: 'WETH',
            decimals: 8,
        },
    ],
    [
        ChainId.BASE,
        {
            address: '0x4200000000000000000000000000000000000006',
            name: 'WETH',
            symbol: 'WETH',
            decimals: 18,
        },
    ],
]);
export var NetworkAvalancheCoins = new Map([
    [
        1,
        {
            address: '0x85f138bfEE4ef8e540890CFb48F620571d67Eda3',
            name: 'Wormhole',
            symbol: 'wavax',
            decimals: 18,
        },
    ],
    [
        ChainId.ARBITRUM,
        {
            address: '0x565609fAF65B92F7be02468acF86f8979423e514',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.OPTIMISM,
        {
            address: '0x8418C1d909842f458c9394886b83F19d62bF1A0D',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.POLYGON,
        {
            address: '0x2C89bbc92BD86F8075d1DEcc58C7F4E0107f286b',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.BSC,
        {
            address: '0x1CE0c2827e2eF14D5C4f29a091d735A204794041',
            name: 'AVAX',
            symbol: 'AVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.AVALANCHE,
        {
            address: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.BLAST,
        {
            address: '0x7D86F00026c2cD8137D60ae85d53c5E5a15B2481',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.FANTOM,
        {
            address: '0x511D35c52a3C244E7b8bd92c0C297755FbD89212',
            name: 'AVAX',
            symbol: 'AVAX',
            decimals: 18,
        },
    ],
    [
        ChainId.SOLANA,
        {
            address: 'KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE',
            name: 'WAVAX',
            symbol: 'WAVAX',
            decimals: 8,
        },
    ],
    // [
    //   ChainId.BASE,
    //   {
    //     address: '0x4200000000000000000000000000000000000006' as Address,
    //     name: 'WAVAX',
    //     symbol: 'WAVAX',
    //     decimals: 18,
    //   },
    // ],
]);
export var NetworkBnbCoins = new Map([
    [
        1,
        {
            address: '0x418D75f65a02b3D53B2418FB8E1fe493759c7605',
            name: 'wbnb',
            symbol: 'USwbnbDC',
            decimals: 18,
        },
    ],
    [
        ChainId.ARBITRUM,
        {
            address: '0x7AF00405916D823eDb1121546EfA6F4972B51b84',
            name: 'WBNB',
            symbol: 'WBNB',
            decimals: 18,
        },
    ],
    // [
    //   ChainId.OPTIMISM,
    //   {
    //     address: '0x8418C1d909842f458c9394886b83F19d62bF1A0D' as Address,
    //     name: 'WBNB',
    //     symbol: 'WBNB',
    //     decimals: 18,
    //   },
    // ],
    [
        ChainId.POLYGON,
        {
            address: '0x3BA4c387f786bFEE076A58914F5Bd38d668B42c3',
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
        },
    ],
    [
        ChainId.BSC,
        {
            address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            name: 'WBNB',
            symbol: 'WBNB',
            decimals: 18,
        },
    ],
    [
        ChainId.AVALANCHE,
        {
            address: '0x264c1383EA520f73dd837F915ef3a732e204a493',
            name: 'WBNB',
            symbol: 'WBNB',
            decimals: 18,
        },
    ],
    // [
    //   ChainId.BLAST,
    //   {
    //     address: '0x85f138bfEE4ef8e540890CFb48F620571d67Eda3' as Address,
    //     name: 'WBNB',
    //     symbol: 'WBNB',
    //     decimals: 18,
    //   },
    // ],
    [
        ChainId.FANTOM,
        {
            address: '0xA686bb86b258adEfC6bbC6E896d7C1520B3d5510',
            name: 'Wormhole',
            symbol: 'WBNB',
            decimals: 18,
        },
    ],
    [
        ChainId.SOLANA,
        {
            address: '9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa',
            name: 'Wormhole',
            symbol: 'WBNB',
            decimals: 8,
        },
    ],
    [
        ChainId.BASE,
        {
            address: '0x7fdAa50d7399ac436943028edA6ed9a1BD89509f',
            name: 'WBNB',
            symbol: 'WBNB',
            decimals: 18,
        },
    ],
]);
export var NetworkSolcoins = new Map([
    [
        1,
        {
            address: '0xD31a59c85aE9D8edEFeC411D448f90841571b89c',
            name: 'wsol',
            symbol: 'wsol',
            decimals: 9,
        },
    ],
    [
        ChainId.ARBITRUM,
        {
            address: '0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 9,
        },
    ],
    [
        ChainId.OPTIMISM,
        {
            address: '0xba1Cf949c382A32a09A17B2AdF3587fc7fA664f1',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 9,
        },
    ],
    [
        ChainId.POLYGON,
        {
            address: '0x7dff46370e9ea5f0bad3c4e29711ad50062ea7a4',
            name: 'SOL',
            symbol: 'SOL',
            decimals: 9,
        },
    ],
    [
        ChainId.BSC,
        {
            address: '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
            name: 'SOL',
            symbol: 'SOL',
            decimals: 18,
        },
    ],
    [
        ChainId.AVALANCHE,
        {
            address: '0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 18,
        },
    ],
    // [
    //   ChainId.BLAST,
    //   {
    //     address: '0x85f138bfEE4ef8e540890CFb48F620571d67Eda3' as Address,
    //     name: 'WBNB',
    //     symbol: 'WBNB',
    //     decimals: 18,
    //   },
    // ],
    [
        ChainId.FANTOM,
        {
            address: '0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 9,
        },
    ],
    [
        ChainId.SOLANA,
        {
            address: 'So11111111111111111111111111111111111111112',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 9,
        },
    ],
    [
        ChainId.BASE,
        {
            address: '0x1C61629598e4a901136a81BC138E5828dc150d67',
            name: 'WSOL',
            symbol: 'WSOL',
            decimals: 9,
        },
    ],
]);
